module.exports = __webpack_public_path__ + "img/image3.6e536472.png";